import { DOCUMENT } from '@angular/common';
import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject, fromEvent, Observable, Subject} from 'rxjs';
import {
    trigger,
    state,
    style,
    animate,
    transition,
    AnimationEvent,

} from '@angular/animations';
import {Router} from '@angular/router';
import { BuscarArchivoMigradoComponent } from '../buscar-archivo-migrado/buscar-archivo-migrado.component';

@Component({
    selector: 'app-custom-modal',
    templateUrl: './custom-modal.component.html',
    styleUrls: ['./custom-modal.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            state('closed', style({
                opacity: 0,
                transform: 'scale(1.3)',
            })),
            transition('open => closed', [
                animate('0.1s')
            ]),
            transition('closed => open', [
                animate('0.2s')
            ]),
        ])
    ]
})
export class CustomModalComponent implements OnInit, OnDestroy {

    @Input() width: string;
    @Input() height: string;
    @Input() zIndex: string;
    @Output() closeModal = new EventEmitter();
    @Input() enterBtn: boolean = false;
    @Input() idExpediente: number;
    @Input() showCloseButton: boolean = true;
    @Input() mostrarVisorMigrado: boolean = false;

    @ViewChild(BuscarArchivoMigradoComponent) childComponent: BuscarArchivoMigradoComponent;

    
    onEnter$: any;

    private $onClose = new Subject<any>()

    isOpen = false;
    showModal = false;
    private isOpen$ = new BehaviorSubject(false);

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.watchState.subscribe(res => {
            this.isOpen = res

            this.isOpen
                ? this.document.body.style.overflowY = 'hidden'
                : this.document.body.style.overflowY = 'auto'
        })
        if ( this.enterBtn === true ) {
            this.onEnter$ = fromEvent( document, 'keyup').subscribe(
                key => {
                    if ( key['code'] === 'Enter' ) {
                        this.router.navigate(['mesa-de-partes/crear-registro/cargo', this.idExpediente]);
                    }
                }
            )
        }
    }
    ngOnDestroy() {
        if ( this.onEnter$ ) {
            this.onEnter$.unsubscribe();
        }
    }

    get watchState(): Observable<boolean> {
        return this.isOpen$.asObservable()
    }

    open() {
        this.isOpen$.next(true);
    }

    close() {
        this.closeModal.emit(true);
        this.isOpen$.next(false);
    }

    toggle() {
        this.isOpen$.next(!this.isOpen);
    }

    onClose(): Observable<null> {
        return this.$onClose.asObservable()
    }

    onAnimationEvent(e: AnimationEvent) {
        if (e.toState === 'closed' && e.phaseName === 'done') {
            this.showModal = false;
            this.$onClose.next(null)
        } else if (e.toState === 'open' && e.phaseName === 'start') {
            this.showModal = true;
        }

    }

}
